var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomPublicPage = function SvgCustomPublicPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.111 9.944H20.89M6.444 20.778h11.112c2.095 0 3.142 0 3.793-.651.651-.651.651-1.698.651-3.794V7.444c0-2.095 0-3.142-.65-3.793C20.697 3 19.65 3 17.555 3H6.444c-2.095 0-3.142 0-3.793.65C2 4.303 2 5.35 2 7.445v8.89c0 2.095 0 3.142.65 3.793.652.65 1.7.65 3.794.65Z",
    stroke: "currentColor",
    strokeWidth: 1.667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.444 6.333a1.111 1.111 0 1 1-2.222 0 1.111 1.111 0 0 1 2.222 0ZM9.778 6.333a1.111 1.111 0 1 1-2.222 0 1.111 1.111 0 0 1 2.222 0ZM13.111 6.333a1.111 1.111 0 1 1-2.222 0 1.111 1.111 0 0 1 2.222 0Z",
    fill: "currentColor"
  })));
};

export default SvgCustomPublicPage;